import { toast } from "sonner";

/**
 * Extrai a mensagem de erro detalhada de um axios error.
 * Tenta backend detail -> HTTP status -> rede -> message.
 */
export function getErrorDetail(error, fallback = "Erro desconhecido") {
  // 1. Backend devolveu detalhe especifico
  const detail = error?.response?.data?.detail;
  if (detail) {
    if (Array.isArray(detail)) {
      return detail.map((d) => d.msg || (typeof d === "string" ? d : JSON.stringify(d))).join("; ");
    }
    if (typeof detail === "string") return detail;
    return JSON.stringify(detail);
  }
  // 2. HTTP status com mensagem
  const status = error?.response?.status;
  if (status) {
    const statusMsg =
      {
        400: "Dados inválidos enviados ao servidor",
        401: "Sessão expirada - faça login novamente",
        403: "Sem permissão para esta operação",
        404: "Recurso não encontrado",
        409: "Conflito - já existe ou estado inválido",
        422: "Validação falhou - verifique os campos",
        500: "Erro interno do servidor",
        502: "Servidor indisponível (bad gateway)",
        503: "Servidor temporariamente indisponível",
      }[status] || `Erro HTTP ${status}`;
    return `${statusMsg} (HTTP ${status})`;
  }
  // 3. Erro de rede
  if (error?.code === "ERR_NETWORK" || error?.message?.includes("Network")) {
    return "Sem ligação ao servidor - verifique a internet";
  }
  if (error?.code === "ECONNABORTED") {
    return "O servidor demorou demasiado a responder - tente novamente";
  }
  // 4. Mensagem JS
  if (error?.message) return error.message;
  return fallback;
}

/**
 * Mostra um toast de erro com titulo (contexto: detalhe) + descricao (detalhe).
 * O detalhe e incluido tanto no titulo como na descricao para garantir
 * visibilidade mesmo em toasts pequenos ou caches antigos.
 * Tambem regista no console para debug.
 */
export function showError(error, contextMessage = "Operação falhou") {
  const detail = getErrorDetail(error);
  // Coloca o detalhe no proprio titulo - assim aparece sempre, mesmo
  // que o componente description esteja escondido ou truncado.
  const title = detail && detail !== contextMessage ? `${contextMessage}: ${detail}` : contextMessage;
  toast.error(title, {
    description: detail,
    duration: 10000,
  });
  console.error(`[${contextMessage}]`, {
    status: error?.response?.status,
    detail: error?.response?.data,
    message: error?.message,
    code: error?.code,
    url: error?.config?.url,
  });
}
